export default "__VITE_ASSET__t$BcpfA1__"